import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosReportesIncapacidadesItemComponent {
}

module.component('recursoshumanosReportesRetencionInfonavitItem', {
  controller: RecursoshumanosReportesIncapacidadesItemComponent,
  template,
  bindings: {
    item: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/reportes/retencion/infonavit/item/component.js